import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import DataBlock from '@/components/DataBlock/DataBlock'
import TextWithLabel from '@/components/TextWithLabel/TextWithLabel'
import { useScreenResolution } from '@/hooks/useScreenResolution'
import { useAllEducationLevels } from '@/queries/useAllEducationLevels'

import styles from './Basket.module.scss'
import type { CurriculumForm } from '../../hooks/useCurriculumForm'
import BasketArraySection from '../BasketArraySection'

const Basket = () => (
  <section className={styles.section}>
    <BasicInformationPreview />
    <BasketArraySection />
  </section>
)

const BasicInformationPreview = () => {
  const { t } = useTranslation('curriculumsManagement')
  const { isMobile } = useScreenResolution()

  const form = useFormContext<CurriculumForm>()
  const { data: allEducationLevels } = useAllEducationLevels()

  const educationLevel = form.watch('educationLevel')
  const name = form.watch('name')
  const aim = form.watch('aim')

  if (!educationLevel || !name || !aim) return null

  const blocks = [
    {
      label: t('label.education-level'),
      value: allEducationLevels?.options?.find(
        option => option.value === educationLevel
      )?.label
    },
    { label: t('label.name'), value: name },
    { label: t('label.aim'), value: t(`aim.${aim}`) }
  ]

  return (
    <>
      {isMobile ? (
        <DataBlock infoArray={blocks} />
      ) : (
        <div className={styles.preview}>
          {blocks.map(block => (
            <TextWithLabel
              key={block.label}
              variant="horizontal"
              size="small"
              label={block.label}
              text={<span className={styles.value}>{block.value}</span>}
            />
          ))}
        </div>
      )}
    </>
  )
}

export default Basket
